import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import * as $ from 'jquery';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
declare function ire(string,{}): any;
@Component({
  selector: 'app-professional-editing-service',
  templateUrl: './professional-editing-service.component.html',
  styleUrls: ['./professional-editing-service.component.scss']
})
export class ProfessionalEditingServiceComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('專業英文編輯服務-Trinka人工智慧文法和寫作工具');
    this.metaTagService.updateTag({ name: 'description', content: "同領域的英文母語博碩士學科專家提供論文編修服務，增加期刊投稿成功機會。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "專業英文編輯服務-Trinka人工智慧文法和寫作工具" });
    this.metaTagService.updateTag({ property: 'og:description', content: "同領域的英文母語博碩士學科專家提供論文編修服務，增加期刊投稿成功機會。"});
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/professional-editing-service' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'robots', content: 'noindex, nofollow' });
    if (isPlatformBrowser(this.platformId)){
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
    ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()})
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }

}
